/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IAppState } from "../types";

import { IServerTimeState } from "./types";

const getPerformanceTimeMs = () =>
  typeof performance !== "undefined" ? performance.now() : Date.now();

export const getCurrentServerTimeMs = (
  serverTime?: Pick<IServerTimeState, "serverTimeMs" | "performanceTimeMs">,
): number | undefined => {
  if (
    serverTime?.serverTimeMs === undefined ||
    serverTime.performanceTimeMs === undefined
  ) {
    return undefined;
  }

  return (
    serverTime.serverTimeMs +
    (getPerformanceTimeMs() - serverTime.performanceTimeMs)
  );
};

export const selectCurrentServerTimeMs = (
  state: IAppState,
): number | undefined => getCurrentServerTimeMs(state.serverTime);
